import {
  usdtAbi,
  LOTTERY_ABI,
  STAKE_ABI,
  NFT_ABI,
  STAKE_PATCH_ABI,
} from "./abi";
import { Notify } from "vant";
import store from "@/store";
import Web3 from "web3";
import {
  USDT_ADDRESS,
  RAD_ADDRESS,
  LOTTERY_ADDRESS,
  STAKE_ADDRESS,
  NFTS_ADDRESS,
  STAKE_PATCH_ADDRESS,
} from "./constants";

export {
  USDT_ADDRESS,
  RAD_ADDRESS,
  LOTTERY_ADDRESS,
  STAKE_ADDRESS,
  NFTS_ADDRESS,
  STAKE_PATCH_ADDRESS,
} from "./constants";

export let gasPrice = "3000000000";
let web3Provider;
export let WEB3;
export let web3js;
let { ethereum } = window;

/** 从 store 读取当前连接的钱包地址 */
export function getAccountAddress() {
  return store.state.user.accountAddress;
}

/** BSC 主网 chainId；97 为 BSC 测试网 */
const networkVersion = "56";
export let isChainId = true;

/** BSC 公开 RPC：无注入钱包时的默认节点 */
export const PUBLIC_RPC_URL = "https://bsc-dataseed1.binance.org";

const readOnlyWeb3 = new Web3(new Web3.providers.HttpProvider(PUBLIC_RPC_URL));

/** 当前读请求是否走公开 RPC（未连接钱包时） */
export function isUsingPublicRpc() {
  return !web3js;
}

/**
 * 公开 RPC 读链失败时不弹错误提示。
 * 连接类错误（含钱包 RPC）同样不提示。
 */
export function shouldNotifyRpcError(err) {
  if (isUsingPublicRpc()) {
    return false;
  }
  const msg = String(
    err?.message || err?.reason || err?.data?.message || err || ""
  ).toLowerCase();
  const connectionHints = [
    "failed to fetch",
    "networkerror",
    "network error",
    "connection error",
    "couldn't connect",
    "could not connect",
    "connect to node",
    "invalid json rpc",
    "timeout",
    "etimedout",
    "econnrefused",
    "enotfound",
    "load failed",
    "cors",
  ];
  if (connectionHints.some((hint) => msg.includes(hint))) {
    return false;
  }
  return true;
}

if (ethereum) {
  web3Provider = ethereum;
} else if (window.web3) {
  web3Provider = Web3.currentProvider;
} else {
  web3Provider = new Web3.providers.HttpProvider(PUBLIC_RPC_URL);
}
WEB3 = new Web3(web3Provider);

let tokenContractInstance;
let radContractInstance;
let lotteryContractInstance;
let stakeContractInstance;
let stakePatchContractInstance;
let nftContractInstance;

let readUsdtContract;
let readRadContract;
let readLotteryContract;
let readStakeContract;
let readStakePatchContract;
let readNftContract;

function createReadContracts(web3) {
  readUsdtContract = new web3.eth.Contract(usdtAbi, USDT_ADDRESS);
  readRadContract = new web3.eth.Contract(usdtAbi, RAD_ADDRESS);
  readLotteryContract = new web3.eth.Contract(LOTTERY_ABI, LOTTERY_ADDRESS);
  readStakeContract = new web3.eth.Contract(STAKE_ABI, STAKE_ADDRESS);
  readStakePatchContract = new web3.eth.Contract(
    STAKE_PATCH_ABI,
    STAKE_PATCH_ADDRESS
  );
  readNftContract = new web3.eth.Contract(NFT_ABI, NFTS_ADDRESS);
}

createReadContracts(readOnlyWeb3);

export function getReadWeb3() {
  return web3js || readOnlyWeb3;
}

export function getWriteWeb3() {
  return web3js || null;
}

export function getUsdtContract() {
  return tokenContractInstance || readUsdtContract;
}

export function getRadContract() {
  return radContractInstance || readRadContract;
}

export function getLotteryContract() {
  return lotteryContractInstance || readLotteryContract;
}

export function getStakeContract() {
  return stakeContractInstance || readStakeContract;
}

export function getStakePatchContract() {
  return stakePatchContractInstance || readStakePatchContract;
}

export function getNftContract() {
  return nftContractInstance || readNftContract;
}

export async function checkNetwork(web3Instance) {
  try {
    const res = await web3Instance.eth.net.getId();
    if (String(res) !== networkVersion) {
      isChainId = false;
      Notify({ type: "danger", message: "error network" });
    } else {
      isChainId = true;
    }
  } catch (err) {
    //
  }
}

export const contractInstanceInit = function (provider, account) {
  web3js = provider;
  store.commit("SET_ADDRESS", account);
  checkNetwork(web3js);
  web3js.eth.getGasPrice().then((res) => {
    gasPrice = res;
  });
  const fromAddress = getAccountAddress();
  return new Promise((resolve) => {
    tokenContractInstance = new web3js.eth.Contract(usdtAbi, USDT_ADDRESS, {
      from: fromAddress,
      gasPrice: "0",
    });
    radContractInstance = new web3js.eth.Contract(usdtAbi, RAD_ADDRESS, {
      from: fromAddress,
      gasPrice: "0",
    });
    lotteryContractInstance = new web3js.eth.Contract(
      LOTTERY_ABI,
      LOTTERY_ADDRESS
    );
    stakeContractInstance = new web3js.eth.Contract(STAKE_ABI, STAKE_ADDRESS);
    stakePatchContractInstance = new web3js.eth.Contract(
      STAKE_PATCH_ABI,
      STAKE_PATCH_ADDRESS
    );
    nftContractInstance = new web3js.eth.Contract(NFT_ABI, NFTS_ADDRESS, {
      from: fromAddress,
      gasPrice: "0",
    });
    createReadContracts(web3js);
    resolve();
  });
};
